export function fromHTML<T = Element>(html: string, trim = true): T {
  html = trim ? html : html.trim();
  if (!html) return null;

  const template = document.createElement("template");
  template.innerHTML = html;
  return template.content.firstChild as T;
}
